import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueLangPlugin from '@piri/vue-lang';

import {
  keys, languages, fallbackLocale, getSelectedLocale,
} from '../../lang';

Vue.use(VueLangPlugin, keys);
Vue.use(VueI18n);

const messages = Object.assign(languages);

export default new VueI18n({
  locale: getSelectedLocale(),
  fallbackLocale,
  messages,
});
